/*
JS Components
*/

import "./lottieAnimation/index";
import "./tabmenu/index";
import "./menu/index";
import "./firebase/index";


// WEBPACK FOOTER //
// ./project/client/src/core/components/index.js